import React from "react";
import "./ProductHeader.css";
const ProductHeader = () => {
  return (
    <>
      <section id="product-header">
        <div id="header-container">
          <div id="header-left"></div>
          <div id="header-right"></div>
        </div>
      </section>

      <section id="product-header-container">
        <div id="product-header-max-width">
          <div className="header-content-container">
            <div className="header-left-content">
              <div>
                <h1 className="secondary-light-text">Do Not Lose Your Audience Ever Again</h1>
                <p className="secondary-light-text">An engagement AI solution for for e-learning, video conferencing and content platforms to understand audience interest in real time and maximize engagement</p>
                <a
                  href="https://focii.brainalive.ai/"
                  target="_blank"
                  rel="noreferrer"
                  id="product-get-started-btn"
                  className="neutral-black-color primary-light-bg "
                >
                  Get Started
                </a>
              </div>
            </div>
            <div className="header-right-content"></div>
          </div>
        </div>
      </section>
    </>
  )
};

export default ProductHeader;
